
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getSegmentacionList, modifySegmentacion, removeSegmentacion, addSegmentacion, updateSegmentacionListDB } from '../../actions/segmentacion_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    }, formControl: {
        marginLeft: '10px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeSegmentacion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            centroId: this.props.centroId ? this.props.centroId : undefined,
        };

    };

    componentDidMount() {

        // Al iniciar la carga de la página, si no existe usuario y no está autorizado se va al home, sino carga la lista
        // de segmentaciones (action).

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getSegmentacionList(this.state.centroId ? this.state.centroId : -1);

    };

    messageDialog = (msg) => {

        // subrutina auxiliar para mostrar mensajes pop-up

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkValues = (linea) => {

        // Comprobar que:
        //      - en "entre" el param1 sea inferior o igual al param2
        //      - que ho hayan duplicados de operador y campo
        //      - que solo se haya informado param2 si es "entre"
        if ( linea.iOperator==4 && linea.param2 && parseInt(linea.param1) > parseInt(linea.param2) )
        {
            this.messageDialog('param1 debe ser mayor o igual que param2');
            return false;
        }

        // const min = this.state.segmentacionLineaList.reduce(function (prev, current) {
        //     return (prev.id < current.id) ? prev : current
        // })
        // const minId = min === undefined ? -1 : (min.id > 0 ? -1 : min.id - 1);

        // if (this.state.partidasPorTipo.find(p => (p.iTipopartidaElem === partida.iTipopartidaElem) && (p.id !== partida.id))) {
        //     this.messageError('Ya existen partidas para este tipo de partida');
        //     return false;
        // }
        return true;
    };



    checkSegmentacion = (segmentacion) => {

        // Llamada desde el Edit chequea que la segmentación sea correcta, 
        // compone el where y cuenta los clientes que hay

        if (this.props.segmentacionList.find(c => (c.descr === segmentacion.descr) && (c.id !== segmentacion.id))) {
            this.messageDialog(`Ya existe una segmentación con descripción ${segmentacion.descr}`);
            return false;
        } else if (!segmentacion.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        } else if (typeof segmentacion.segmentacionLineaList === 'undefined' || segmentacion.segmentacionLineaList.length === 0) {
            this.messageDialog('Debe existir algún criterio para la segmentación');
            return false;
        } 
        segmentacion.segmentacionLineaList.forEach((linea) => 
        {
            // Comprobar que:
            //      - en "entre" el param1 sea inferior o igual al param2
            //      - que ho hayan duplicados de operador y campo
            //      - que solo se haya informado param2 si es "entre"
            if ( linea.iOperator==4 && linea.param2 && parseInt(linea.param1) > parseInt(linea.param2) )
            {
                this.messageDialog('param1 debe ser mayor o igual que param2');
                return false;
            }
        });

        return true;
    };

    addNewSegmentacionCallback = (segmentacion) => {

        // Llamda desde el Edit añade (action) la segmentación

        this.props.setSaveState(true);
        this.props.addSegmentacion(segmentacion);
    };

    newSegmentacion = () => {
        
        // Perimte añadir una segmentación (no editarla porque está vacía) siempre y cuando el centro
        // esté definido y no sea el centro Ilusiona global

        if (this.state.centroId !== undefined && this.state.centroId !== 10 && this.state.centroId !== -1) {
            this.props.openDialog('EditSegmentacion', {
                segmentacion: {},
                okHandler: this.addNewSegmentacionCallback,
                checkSegmentacion: this.checkSegmentacion,
                centroId: this.state.centroId,
                checkValues: this.checkValues,
            }, uuidv4());

        }
        else {
            this.messageDialog('Debe escoger un centro antes de crear una segmentación');
        }
    };


    editSegmentacion = (segmentacion) => {

        // Permite editar la segmentación que se pasa por argumento

        this.props.openDialog('EditSegmentacion', {
            segmentacion: segmentacion,
            checkSegmentacion: this.checkSegmentacion,
            okHandler: (sf) => {
                this.props.setSaveState(true);
                this.props.modifySegmentacion(sf);
            },
            centroId: this.state.centroId,
            userId: this.props.user.id,
            checkValues: this.checkValues,

        }, uuidv4());
    };

    handleDeleteRow = (segmentacion) => {

        // Elimina (action) la segmentación

        this.props.setSaveState(true);
        this.props.removeSegmentacion(segmentacion);
    };

    // ddw centros events
    centroSelectList = () => {

        // Auxiliar para el ddw de centros que devuelve la lista de todos los centros activos y que no sean grupo

        return this.props.centros.filter(c => c.isGroup === false && c.activo === 1).map((centro, index) => {
            return (
                <option key={centro.id} value={centro.id}>{centro.centro}</option>
            );
        })
    };

    handleChangeSelectCentro = event => {

        // Al seleccionar un centro se modifica el estado y se vuelve a seleccionar (action) todas las segmentaciones

        const c_id = event.target.value ? event.target.value : 1;
        this.setState({ ...this.state, centroId: c_id });
        this.props.getSegmentacionList(event.target.value ? event.target.value : 1);
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>

                    {this.props.centros ?
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="segmentacion-placeholder">
                                Centro
                            </InputLabel>
                            <Select
                                native
                                value={this.props.centroId}
                                onChange={(event) => this.handleChangeSelectCentro(event)}
                            >
                                {this.props.centros.find(c => c.id === this.props.centroId) === undefined ? <option key={'centro_0'} value={0}>{"Seleccione un centro"}</option> : ''}
                                {this.centroSelectList()}
                            </Select>
                        </FormControl>
                        : ''}

                    <NeuriteGrid
                        id="m_r_p"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: false, dragable: false, width: 150 },
                            { key: 'where_clause', name: 'Where clause', editable: false, dragable: false, width: 150 },
                            { key: 'fecha', name: 'Fecha contador', tooltip: 'Fecha del cálculo del contador', type: 'date', editable: false, dragable: false, width: 80 },
                            { key: 'contador', name: 'Contador', tooltip: 'Número clientes segmenados', type: 'int', editable: false, dragable: false, width: 65 },
                        ]}
                        rows={this.props.segmentacionList}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newSegmentacion}
                        // onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        onEditClick={this.editSegmentacion}
                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {

                    // Coloca los elementos a añadir con el identificador -1 (que luego en el backend pasarán a 0 para
                    // que entity framework los identifique como nuevos) y actualiza toda la lista

                    this.props.segmentacionList.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateSegmentacionListDB(this.props.segmentacionList, this.state.centroId)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeSegmentacion.propTypes = {
    //state
    segmentacionList: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getSegmentacionList: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifySegmentacion: PropTypes.func.isRequired,
    removeSegmentacion: PropTypes.func.isRequired,
    addSegmentacion: PropTypes.func.isRequired,
    updateSegmentacionListDB: PropTypes.func.isRequired,
    // user ddw
    centros: PropTypes.array.isRequired,
    centroId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        segmentacionList: state.segmentacion.segmentacionList,

        user: state.oidc.user,
        centros: state.centros.centros,
        centroId: state.segmentacion.centroId
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getSegmentacionList,
        openDialog,
        hideDialog,
        modifySegmentacion,
        removeSegmentacion,
        addSegmentacion,
        updateSegmentacionListDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeSegmentacion));